import Update_Icon from "../images/table/Update_icon.svg";
import Delete_Icon from "../images/table/Delete_icon.svg";

export const FLEET_SITE_ROW_ACTIONS = {
  updateSite: {
    id: "update",
    label: "Update",
    icon: Update_Icon,
    path: "/site",
    permission: { apiPath: "/api/site", action: "PUT" },
  },
  deleteSite: {
    id: "delete",
    label: "Delete",
    className: "delete",
    icon: Delete_Icon,
    path: "/site/",
    permission: { apiPath: "/api/site", action: "DELETE" },
  },
};

export function computeFleetSiteMetric(metricKey, siteData = []) {
  const sites = Array.isArray(siteData) ? siteData : [];

  switch (metricKey) {
    case "totalSites":
      return sites.length;
    default:
      return 0;
  }
}
